/**
 * Sistema de detecção de versão da aplicação
 * Detecta quando uma nova versão está disponível e força reload
 */

const VERSION_KEY = 'app_version';
const VERSION_CHECK_INTERVAL = 5 * 60 * 1000; // 5 minutos

export function getCurrentVersion(): string {
  // Usar timestamp de build ou hash do vite
  return import.meta.env.VITE_BUILD_TIMESTAMP || Date.now().toString();
}

export function getCachedVersion(): string | null {
  return localStorage.getItem(VERSION_KEY);
}

export function setCachedVersion(version: string): void {
  localStorage.setItem(VERSION_KEY, version);
}

export function clearVersionCache(): void {
  localStorage.removeItem(VERSION_KEY);
}

export function isNewVersionAvailable(): boolean {
  const current = getCurrentVersion();
  const cached = getCachedVersion();
  
  if (!cached) {
    setCachedVersion(current);
    return false;
  }
  
  return current !== cached;
}

export function forceAppUpdate(): void {
  clearVersionCache();
  clearAllCaches().then(() => {
    window.location.reload();
  });
}

export async function clearAllCaches(): Promise<void> {
  if ('caches' in window) {
    const cacheNames = await caches.keys();
    await Promise.all(
      cacheNames.map(cacheName => caches.delete(cacheName))
    );
  }
  
  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(
      registrations.map(registration => registration.unregister())
    );
  }
}

export function startVersionCheck(onNewVersion?: () => void): () => void {
  const checkVersion = () => {
    if (isNewVersionAvailable()) {
      console.log('🔄 Nova versão detectada');
      onNewVersion?.();
    }
  };
  
  const interval = setInterval(checkVersion, VERSION_CHECK_INTERVAL);
  
  // Retornar função de cleanup
  return () => clearInterval(interval);
}
